'use strict';

//libraries
var React = require('react');
var ClassNames = require('classnames');
var _ = require('lodash');
var Typeahead = require('react-typeahead').Typeahead;
//constants
var Constants = require('../../constants/YourDetailsConstants');
var RESIDENTIAL = Constants.Values.RESIDENTIAL;
var POSTAL = Constants.Values.POSTAL;
var Values = Constants.Values;
var ApplicationConstants = require('../../constants/ApplicationConstants');
var YesNoRadioData = ApplicationConstants.YesNoRadioData;
var ContentService = require('../../services/ContentService.js');
var BeneficiaryConstant = require('../../constants/BeneficiaryDetailsConstant.js');
var Products = require('../../utils/Products');

//action
var YourDetailsAction = require('../../actions/YourDetailsActions.js');
var AddressAction = require('../../actions/AddressActions.js');
var AddressStore = require('../../stores/AddressStore.js');
var BeneficiaryAction = require('../../actions/BeneficiaryDetailsActions.js');

//component
var TextInputHelper = require('../Common/TextInputHelper.jsx');
var Country = require('../YourDetails/Country.jsx');
var InlineMessage = require('../Common/InlineMessage.jsx');
var TextInput = require('../Common/TextInput.jsx');
var SelectInput = require('../Common/SelectInput.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var Spinner = require('../Common/Spinner.jsx');

var AccountType = require('../../constants/ApplicationConstants').AccountTypeCodes;

var Address = React.createClass({
    getDefaultProps: function () {
        return {
            errorList: [],
            section: '',
            index: '',
            withPostalAddress: true,
            type: RESIDENTIAL
        };
    },

    generateHeaders() {
        if (this.props.type === BeneficiaryConstant.BENEFICARY) {

            return BeneficiaryConstant.AddressLabel;
        } else {
            var CaptionType = Constants.Labels.address;
            switch (this.props.accountType) {
                case AccountType.COMPANY:
                case AccountType.PARTNERSHIP:
                case AccountType.SMSF:
                case AccountType.TRUST:
                    return _.assign(CaptionType.company, CaptionType.business);
                case AccountType.SOLE_TRADER:
                    return _.assign(CaptionType.soleTrader, CaptionType.business);
                default:
                    return CaptionType.residential;
            }
        }
    },

    getActionType() {
        if (this.props.type === Values.RESIDENTIAL) {
            return YourDetailsAction.saveAddressInfo;
        }
        else if (this.props.type === Values.BUSINESS) {
            return YourDetailsAction.saveBusinessAddress;
        }
        else if (this.props.type === BeneficiaryConstant.BENEFICARY) {
            return BeneficiaryAction.saveBeneficiaryAddress;
        }
    },

    getInitialState: function () {
        return {
            getAusState: [
            { value: 'NSW', label: 'NSW' },
            { value: 'VIC', label: 'VIC' },
            { value: 'QLD', label: 'QLD' },
            { value: 'WA', label: 'WA' },
            { value: 'SA', label: 'SA' },
            { value: 'TAS', label: 'TAS' },
            { value: 'ACT', label: 'ACT' },
            { value: 'NT', label: 'NT' }
            ],
            resOptions: [],
            postalOptions: [],
            isResAddressFound: true,
            isResidentialTextHelperHidden: true,
            isPostalAddressFound: true,
            isPostalTextHelperHidden: true,
            action: this.getActionType(),
            isResLoading: false,
            isPostalLoading: false,
            isPostalAddressOnly: false
        };
    },

    getId: function (model) {
        return this.props.section + model + this.props.index;
    },

    componentDidMount: function () {
        AddressStore.addChangeListener(this.handleAddressStoreChange);
    },

    componentWillUnmount: function () {
        AddressStore.removeChangeListener(this.handleAddressStoreChange);
    },

    handleAddressStoreChange: function () {
        //Validation result
        var residentialResult = AddressStore.getResidentialValidationResult(this.getId('residential'));
        var postalResult = AddressStore.getPostalValidationResult(this.getId('postal'));

        this.setState({
            resOptions: AddressStore.getResidentialOptions(),
            postalOptions: AddressStore.getPostalOptions(),
            isResAddressFound: residentialResult !== false,
            isPostalAddressFound: postalResult !== false,
            isResLoading: false,
            isPostalLoading: false
        });
    },

    _addressValidation: function (type, value) {
        AddressAction.validateAddressAndPostal(this.getId(type), value, type, type === RESIDENTIAL ? 'isResAddressFound' : 'isPostalAddressFound', this.props.index, this.props.type);
    },

    _selectAddress: function(type){
        if (type === RESIDENTIAL){
            this.setState({isResAddressFound: true});
            AddressAction.resetResValidation(this.getId(type));
        }
        else if(type === POSTAL){
            this.setState({isPostalAddressFound: true});
            AddressAction.resetPostalValidation(this.getId(type));
        }
        this._clearOptions(type);
    },

    _clearOptions: function (type) {
        if (type === RESIDENTIAL) {
            this.setState({ resOptions: [] });
        }
        else {
            this.setState({ postalOptions: [] });
        }
    },

    _onChange: function (type, event) {
        if (event.target.value) {
            AddressAction.fetchOptions(this.getId(type), event.target.value, type);
        }
        else {
            this._clearOptions(type);
        }
    },

    residentialTypeHeadOnBlur: function (e) {
        var value = e.target.value.trim();
        this.setState({ isResidentialTextHelperHidden: true });
        
        if (value) {
            this.setState({isResLoading:true});
            this._addressValidation(RESIDENTIAL, value);
            if (this.props.type === BeneficiaryConstant.BENEFICARY) {
                this.state.action('residential', e.target.id, value);
            }
        } else {
            AddressAction.resetResValidation(this.getId(RESIDENTIAL));
            this.state.action('residential', e.target.id, value, this.props.index);
        }
    },

    residentialTypeHeadOnFocus: function () {
        this.setState({ isResidentialTextHelperHidden: false });
    },

    handleResidencialOnClick: function (event) {
        event.preventDefault();
        this.state.action('defineAddressLine', null, ApplicationConstants.YesNoValues.YES, this.props.index);
        this.resetPostalAddressErrors();
        var id = this.getId('address1');
        this.refs[id].inputFocus();
    },

    saveAddressInfo: function (e) {
        this.state.action(e.target.model, e.target.id, e.target.value, this.props.index);
    },

    resetPostalAddressErrors: function () {
        YourDetailsAction.removeValidation([this.getId('postal'), this.getId('postalCountry'), this.getId('postalAddress1'),
            this.getId('postalAddress2'), this.getId('postalCityStatePostCode'), this.getId('postalAusState'), this.getId('postalPostCode')]);
    },

    handlePostalAddressSelection: function (event) {
        this.setState({ isPostalAddressFound: true });
        this.saveAddressInfo(event);
        if (event.target.value === ApplicationConstants.YesNoValues.YES) {
            this.resetPostalAddressErrors();
            AddressAction.resetPostalValidation(this.getId(POSTAL));
        }
    },

    postalTypeHeadOnBlur: function (e) {
        var value = e.target.value.trim();
        this.setState({ isPostalTextHelperHidden: true});
        
        if (value) {
            this.setState({isPostalLoading: true});
            this._addressValidation(POSTAL, value);
            if (this.props.type === BeneficiaryConstant.BENEFICARY) {
                this.state.action('postal', e.target.id, value);
            }
        } else {
            AddressAction.resetPostalValidation(this.getId(POSTAL));
            this.state.action('postal', e.target.id, value, this.props.index);
        }
    },

    postalTypeHeadOnFocus: function () {
        this.setState({ isPostalTextHelperHidden: false });
    },

    handlePostalOnClick: function (event) {
        event.preventDefault();
        this.state.action('definePostalAddressLine', null, ApplicationConstants.YesNoValues.YES, this.props.index);
        var id = this.getId('postalAddress1')
        this.refs[id].inputFocus();
    },

    handleCountryChange: function (event) { 
        this.saveAddressInfo(event);
    },

    revalidateField: function (fieldId) {
        var errors = _.filter(this.props.errorList, { id: this.getId(fieldId) });
        if (errors.length > 0) {
            this.state.action(fieldId, this.getId(fieldId), this.props.data[fieldId], this.props.index);
        }
    },

    renderLineByLine: function (residential, labels, isCountryAus) {
        var address1, address2, city, country, allowedCountry, countryNotes, isIndividualAddress = labels.residence === Constants.Labels.address.residential.residence;
        var isSuperOrPension = Products.isSuper(this.props.productId) || Products.isPension(this.props.productId), isInvestment = Products.isInvestment(this.props.productId), isNotNewZealandResident = this.props.data.resCountry !== Values.COUNTRY_NEW_ZEALAND, isNotAustralianResident = this.props.data.resCountry !== Values.COUNTRY_AUSTRALIA;
        if (residential && isInvestment && isIndividualAddress) {
            allowedCountry = [Values.COUNTRY_AUSTRALIA, Values.COUNTRY_NEW_ZEALAND];
            countryNotes = Values.REQUIRED_AU_OR_NZ_RESIDENT;
        }
        if (residential && isSuperOrPension && isIndividualAddress) {
            allowedCountry = [Values.COUNTRY_AUSTRALIA];
            countryNotes = Values.REQUIRED_AU_RESIDENT;
        }
        if (residential) {     
            if((isIndividualAddress && this.props.data.resCountry.length > 0) &&  
                ((isNotAustralianResident && isSuperOrPension) || (isInvestment && isNotAustralianResident && isNotNewZealandResident))) {
                this.props.data.resCountry = '';
                this.props.data.address1 = '';
                this.props.data.address2 = '';
                this.props.data.cityStatePostCode = '';
            }            
            
            address1 = { label: labels.address1, id: this.getId('address1'), value: this.props.data.address1, model: 'address1', placeholder: 'No PO Box or property name', disabled: this.props.data.addressLineReadonly };
            address2 = { label: labels.address2, id: this.getId('address2'), value: this.props.data.address2, model: 'address2', disabled: this.props.data.addressLineReadonly };
            city = { label: (isCountryAus) ? labels.CitySuburb : labels.CityStatePostCode, id: this.getId('cityStatePostCode'), value: this.props.data.cityStatePostCode, model: 'cityStatePostCode', disabled: this.props.data.cityStatePostCodeReadonly };
            country = { label: labels.country, id: this.getId('resCountry'), value: this.props.data.resCountry, model: 'resCountry', disabled: this.props.data.resCountryReadonly };
        }
        else {
            address1 = { label: 'Postal address line 1', id: this.getId('postalAddress1'), value: this.props.data.postalAddress1, model: 'postalAddress1', disabled: this.props.data.postalAddressLineReadonly };
            address2 = { label: 'Postal address line 2', id: this.getId('postalAddress2'), value: this.props.data.postalAddress2, model: 'postalAddress2', disabled: this.props.data.postalAddressLineReadonly };
            city = { label: (isCountryAus) ? 'City/Suburb' : 'City/State/Postcode', id: this.getId('postalCityStatePostCode'), value: this.props.data.postalCityStatePostCode, model: 'postalCityStatePostCode', disabled: this.props.data.postalCityStatePostCodeReadonly };
            country = { label: 'Country', id: this.getId('postalCountry'), value: this.props.data.postalCountry, model: 'postalCountry', disabled: this.props.data.postalCountryReadonly };
        }
        return (<div>
                    <TextInput id={address1.id}
                               ref={address1.id}
                               label={address1.label}
                               value={address1.value}
                               placeholder={address1.placeholder || ''}
                               onBlur={this.saveAddressInfo}
                               model={address1.model}
                               errorList={this.props.errorList}
                               isDisabled={address1.disabled} />
                    <TextInput id={address2.id}
                               label={address2.label}
                               value={address2.value}
                               onBlur={this.saveAddressInfo}
                               model={address2.model}
                               errorList={this.props.errorList}
                               isDisabled={address2.disabled} />
                    <TextInput id={city.id}
                               label={city.label}
                               value={city.value}
                               onBlur={this.saveAddressInfo}
                               model={city.model}
                               errorList={this.props.errorList}
                               isDisabled={city.disabled} />
                    <Country label={country.label}
                             id={country.id}
                             value={country.value}
                             onBlur={this.handleCountryChange}
                             model={country.model}
                             errorList={this.props.errorList}
                             disabled={country.disabled} 
                             allowedCountryList={allowedCountry}
                             notes={countryNotes} />
        </div>);
    },
    renderState: function (residential, labels) {
        var state, postCode;
        if (residential) {
            state = { label: labels.state, id: this.getId('resAusState'), value: this.props.data.resAusState, model: 'resAusState', disabled: this.props.data.resAusStateReadonly };
            postCode = { label: labels.postcode, id: this.getId('postCode'), value: this.props.data.postCode, model: 'postCode', disabled: this.props.data.postCodeReadonly };
        }
        else {
            state = { label: 'State', id: this.getId('postalAusState'), value: this.props.data.postalAusState, model: 'postalAusState', disabled: this.props.data.postalAusStateReadonly }
            postCode = { label: 'Postcode', id: this.getId('postalPostCode'), value: this.props.data.postalPostCode, model: 'postalPostCode', disabled: this.props.data.postalPostCodeReadonly }
        }
        return (<div>
                    <SelectInput label={state.label}
                                 id={state.id}
                                 className="select-state"
                                 options={this.state.getAusState}
                                 clearable={false}
                                 searchable={false}
                                 value={state.value}
                                 onChange={this.saveAddressInfo}
                                 model={state.model}
                                 errorList={this.props.errorList}
                                 disabled={state.disabled} />
                    <TextInput id={postCode.id}
                               label={postCode.label}
                               value={postCode.value}
                               onBlur={this.saveAddressInfo}
                               model={postCode.model}
                               errorList={this.props.errorList}
                               isDisabled={postCode.disabled} />
        </div>);
    },
    render: function () {
        var labels = this.generateHeaders();
        var postalAddressSelection = null, isResPostalAddress = null, isDefineAddressLine = null;

        var inlineError = function (data, index) {
            return (<InlineMessage key={index}
                                   id={'error-message-' + data.id}
                                   type={data.type}
                                   message={data.message
            } />);
        };

        var addressNotFoundError = function (type) {
            return <InlineMessage  id={'error-message-addressNotFound-' + type}
                                   type="error"
                                   errorClickHandler={(type === RESIDENTIAL) ? this.handleResidencialOnClick : this.handlePostalOnClick}
                                   isHidden={(type === RESIDENTIAL) ? this.state.isResAddressFound : this.state.isPostalAddressFound}
                                   message={ContentService.getContent().yourDetails.addressNotFoundError} />
        }.bind(this);
        if (this.props.withPostalAddress) {
            postalAddressSelection = <RadioInput id={this.getId('isResPostalAdd')}
                                                 data={YesNoRadioData}
                                                 value={this.props.data.isResPostalAdd}
                                                 label={labels.isResPostalAdd}
                                                 onChange={this.handlePostalAddressSelection}
                                                 model="isResPostalAdd"
                                                 errorList={this.props.errorList
            } />;
        }

        //Note: Section for residential address
        if (this.props.data.defineAddressLine === ApplicationConstants.YesNoValues.YES) {
            var isResCountryAus = (this.props.data.resCountry === Values.COUNTRY_AUSTRALIA);
            isDefineAddressLine =
               <div>
                   {this.renderLineByLine(true, labels, isResCountryAus)}
                   {isResCountryAus ? this.renderState(true, labels) : null}
                   {postalAddressSelection}
               </div>;
        } else if (!this.props.isPostalAddressOnly) {
            var residentialError = _.filter(this.props.errorList, { id: this.getId('residential') }).map(inlineError);
            //Note: Display predictive search option
            isDefineAddressLine =
            <div>
               <div className={ClassNames('form-section', { 'has-warning': !this.state.isResAddressFound || residentialError.length })}>
                   <div className="form-label-section">
                        <label htmlFor="residential-address">{labels.residence}</label>
                   </div>
                   <div className="form-inline">
                        <Typeahead inputProps={{ id: this.getId('residential') }}
                                   value={this.props.data.residential}
                                   options={this.state.resOptions}
                                   onOptionSelected={this._selectAddress.bind(this, RESIDENTIAL)}
                                   onChange={this._onChange.bind(this, RESIDENTIAL)}
                                   onBlur={this.residentialTypeHeadOnBlur}
                                   onFocus={this.residentialTypeHeadOnFocus}
                                   placeholder="No PO Box or property name"
                                   maxVisible={5}
                                   customClasses={{
                                input: 'form-control input-lg',
                                results: 'typeahead-results'
                            }} /><Spinner customClass="center-spinner address-spinner" hide={!this.state.isResLoading} />
                        <TextInputHelper isHidden={this.state.isResidentialTextHelperHidden} />
                   </div>
                   {addressNotFoundError(RESIDENTIAL)}
                   {residentialError}
               </div>
                {postalAddressSelection}
            </div>;
        }

        //Note: Section for postal address
        if (this.props.withPostalAddress || this.props.isPostalAddressOnly) {
            if (this.props.data.isResPostalAdd === ApplicationConstants.YesNoValues.NO || this.props.isPostalAddressOnly) {
                if (this.props.data.definePostalAddressLine === ApplicationConstants.YesNoValues.YES) {
                    var isPostalResCountryAus = (this.props.data.postalCountry === Values.COUNTRY_AUSTRALIA);
                    isResPostalAddress =
                        <div>
                        {this.renderLineByLine(false, labels, isPostalResCountryAus)}
                        {isPostalResCountryAus ? this.renderState(false, labels) : null}
                    </div>;
                } else {
                    var postalError = _.filter(this.props.errorList, { id: this.getId('postal') }).map(inlineError);
                    //Note: Display predictive search option
                    isResPostalAddress =
                        <div id={this
                            .getId('postal')} className={
                            ClassNames('form-section',
                            { 'has-warning': !this.state.isPostalAddressFound || postalError.length })}>
                        <div className="form-label-section">
                            <label htmlFor="postal-address">Postal address</label>
                        </div>
                        <div className="form-inline">
                           <Typeahead inputProps={{ id: this.getId('postal') }}
                        value={this.props.data.postal}
                        options={this.state.postalOptions}
                        onOptionSelected={this._selectAddress.bind(this, POSTAL)}
                        onChange={this._onChange.bind(this, POSTAL)}
                        onBlur={this.postalTypeHeadOnBlur}
                        onFocus={this.postalTypeHeadOnFocus}
                        maxVisible={5}
                        customClasses={{
                            input: 'form-control input-lg',
                            results: 'typeahead-results'
                        }} /><Spinner customClass="center-spinner" hide={!this.state.isPostalLoading} />
                            <TextInputHelper isHidden={this.state.isPostalTextHelperHidden} />
                        </div>{addressNotFoundError(POSTAL)}{postalError}
                        </div>;
                }
            }
        }

        return (
            <div>{isDefineAddressLine}{isResPostalAddress}
            </div>
		);
    }
});

module.exports = Address


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/Address.jsx